import styled, { css } from 'styled-components';
import { mq, getTextType, px2rem } from '../../../stylesheets/tools';

const StyledEventDate = styled.div`
  ${props =>
    props.showWeekday &&
    css`
      position: absolute;
      top: ${props.isBig ? '-40px' : '-20px'};
    `}
  ${props =>
    !props.showWeekday &&
    css`
      position: relative;
    `}
  display: inline-flex;
  justify-content: flex-end;

  ${props =>
    props.isBig &&
    css`
      .eventDate__startdate,
      .eventDate__enddate {
        width: ${px2rem('140px')};
        height: ${px2rem('140px')};
      }

      .eventDate__shape-wrapper {
        width: ${px2rem('140px')};
      }
    `}
  
  ${props =>
    props.isSmall &&
    css`
      .eventDate__startdate,
      .eventDate__enddate {
        width: ${px2rem('80px')};
        height: ${px2rem('80px')};

        .eventDate__day,
        .eventDate__month {
          font-size: ${px2rem('20px')}!important;
          line-height: 1.25 !important;
        }
        .eventDate__year {
          font-size: ${px2rem('12px')}!important;
          line-height: 1.25 !important;
        }
      }

      .eventDate__shape-wrapper {
        width: ${px2rem('80px')};
      }
    `}
  
  ${props =>
    !props.isBig &&
    !props.isSmall &&
    css`
      .eventDate__startdate,
      .eventDate__enddate {
        width: ${px2rem('90px')};
        height: ${px2rem('90px')};

        ${mq('m')} {
          width: ${px2rem('100px')};
          height: ${px2rem('100px')};
        }
      }

      .eventDate__shape-wrapper {
        width: ${px2rem('90px')};

        ${mq('m')} {
          width: ${px2rem('100px')};
        }
      }
    `}
  .eventDate__startdate,
  .eventDate__enddate {
    position: relative;
    margin-right: 5px;
    text-align: center;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;

    ${mq('m')} {
      margin-right: 10px;
    }

    .eventDate__day,
    .eventDate__month {
      ${getTextType('tertiary')}
      text-transform: uppercase;
      position: relative;
    }

    .eventDate__year {
      ${getTextType('subline')}
      position: relative;
    }
  }

  .eventDate__enddate:before {
    content: '';
    position: absolute;
    top: 50%;
    left: -20px;
    width: 30px;
    height: 2px;
    background: #000;
    border-radius: 2px 0 0 2px;
    z-index: 1;
  }

  .eventDate__shape-wrapper {
    position: absolute;
    top: 0;
    left: 0;

    svg path {
      fill: #fff;
    }
  }

  .eventDate__arrow-wrapper {
    position: absolute;
    width: 40px;
    
    ${props =>
      props.timeOnTop
        ? css`
            top: 15px;
            right: -20px;
          `
        : css`
            bottom: -5px;
            right: -2px;
            transform: rotate(90deg);
          `}

    ${mq('m')} {
      bottom: auto;
      width: 65px;
      top: 15px;
      right: -35px;
      transform: rotate(0deg);
    }

    ${props =>
      props.isTeaser &&
      !props.period &&
      css`
        top: auto;
        bottom: 25px;
        right: -15px;
        transform: rotate(0deg);
      `}
      ${props =>
        props.isTeaser &&
        !props.timeOnTop &&
        css`
          ${mq('m')} {
            width: 40px;
            top: auto;
            bottom: 13px;
            right: -20px;
          }
        `}
      ${props =>
        props.isTeaser &&
        props.timeOnTop &&
        css`
          ${mq('m')} {
            width: 40px;
            bottom: auto;
            right: -20px;
          }
        `}
    }
  }

  .eventDate__arrow,
  .eventDate__shape {
    position: relative;
    height: 0;
    width: 100%;

    svg {
      display: block;
      height: 100%;
      left: 0;
      overflow: visible !important;
      position: absolute;
      top: 0;
      width: 100%;
    }
  }

  .eventDate__arrow {
    padding-bottom: calc(32 / 98 * 100%);
  }

  .eventDate__shape {
    padding-bottom: calc(164 / 164 * 100%);
  }
`;

export default StyledEventDate;
